// extracted by mini-css-extract-plugin
export default {"header2":"knH91WLyilMsy_kGBxCQ","skipMargin":"RVtdqDR8cAxnYxzt02xj","wide":"SbYktT975vop9Y7Z13Hl","placeHolderShimmer":"XRKCrkk8T4E2i5BGzM0Q"};